module.exports = __webpack_public_path__ + "img/btn-play-video@2x.b9fe7fa2.png";